/**
 * Module movements devance
 * @module app.devance.movements
 */
define([
    'angular',
    'modules/devance/movements/controllers/parcMvtsCtrl',
    'modules/devance/movements/controllers/servMvtsCtrl',
    'modules/devance/movements/factories/mvtsService',
    'modules/devance/movements/factories/x3Service',
    'modules/devance/common/devanceProvider'
], function(angular) {
    /**
     * Configure routing
     * @param $routeProvider
     */
    function devanceHomeRouter($routeProvider) {
        $routeProvider.when('/devance/pos-movements/', {
            templateUrl: 'devance/movements/partials/posMvts.html',
            controller: 'ParcMvtsCtrl',
            controllerAs: 'pmCtrl',
            params: {
                menuTitle: 'Mouvements de parc Devance'
            }
        });

        $routeProvider.when('/devance/services-movements/', {
            templateUrl: 'devance/movements/partials/servMvts.html',
            controller: 'ServMvtsCtrl',
            controllerAs: 'smCtrl',
            params: {
                menuTitle: 'Mouvements de services Devance'
            }
        });
    }

    devanceHomeRouter.$inject = ['$routeProvider'];

    angular
        .module('app.devance.movements', [
            'app.devance.movements.parcMvtsCtrl',
            'app.devance.movements.servMvtsCtrl',
            'app.devance.movements.mvtsService',
            'app.devance.movements.x3Service',
            'app.devance.common.devanceProvider'
        ])
        .config(devanceHomeRouter);
});
